import { fromJS } from 'immutable';
import { fetchingState } from '@constants';
import * as _ from 'lodash';
import * as actions from '../actions/assignment';
import { START, SUCCESS, ERROR } from '@modules/appraisal/actions/global';

const initialState = fromJS({
  changesetProperties: {
    data: [],
    state: null,
  },
  prioritySelection: {
    excludeT: false,
    includeIR: false,
    includeAD: false,
    includePI: false,
    includePT: false,
    includePD: false,
    includeT: false,
    includeS: false,
    includeBPN: false,
    inspectionReasonCodes: [],
    inspectionADStart: null,
    inspectionADEnd: null,
    permitIssuerCodes: [],
    permitTypes: [],
    permitNumbers: [],
    excludeTags: [],
    pdStart: null,
    pdEnd: null,
    propertyTags: [],
    stateCodes: [],
  },
});

const SearchReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.SET_PRIORITY_SELECTION: {
      console.log(action);
      return state.setIn(
        ['prioritySelection', action.payload.type],
        action.payload.data,
      );
    }
    case actions.FETCH_CHANGESET_GROUP_PROPERTIES[START]: {
      return state
        .setIn(['changesetProperties', 'state'], fetchingState.FETCHING)
        .setIn(
          ['changesetProperties', 'data'],
          fromJS(_.get(action, 'data.results', []) || []),
        );
    }
    case actions.FETCH_CHANGESET_GROUP_PROPERTIES[SUCCESS]: {
      return state
        .setIn(['changesetProperties', 'state'], fetchingState.LOADED)
        .setIn(
          ['changesetProperties', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case actions.FETCH_CHANGESET_GROUP_PROPERTIES[ERROR]: {
      return state.setIn(['changesetProperties', 'state'], fetchingState.ERROR);
    }
    default: {
      return state;
    }
  }
};

export default SearchReducer;
